export { default } from 'components/legislation-reference'
